/* eslint-disable */
/**
 * Catalyst.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { getApiBaseHref, addToHttpParams, httpParameterCodec, canConsumeForm as rawCanConsumeForm, encodeURIComponent, String, getHttpContext, httpMethods } from "src/standard/ts/apiUtils";
import { appendFiltersToFormParams } from "src/standard/ts/appendFiltersToFormParams";

const baseUrl = '';
const defaultHeaders = new HttpHeaders();

// @ts-ignore
import { BusinessResultOfCommandResult } from '../model/businessResultOfCommandResult';
// @ts-ignore
import { BusinessResultOfDownloadEngagementSnapshotResult } from '../model/businessResultOfDownloadEngagementSnapshotResult';
// @ts-ignore
import { BusinessResultOfListOfEngagementSnapshot } from '../model/businessResultOfListOfEngagementSnapshot';
// @ts-ignore
import { CreateSnapshotCommandRequest } from '../model/createSnapshotCommandRequest';
// @ts-ignore
import { DeleteSnapshotCommandRequest } from '../model/deleteSnapshotCommandRequest';
// @ts-ignore
import { DownloadSnapshotCommandRequest } from '../model/downloadSnapshotCommandRequest';
// @ts-ignore
import { SnapshotsByEngagementIdQueryRequest } from '../model/snapshotsByEngagementIdQueryRequest';

import { COLLECTION_FORMATS }                     from '../variables';

import type {
    SnapshotServiceInterface,
    SnapshotCreateSnapshotRequestParams,
    SnapshotDeleteSnapshotRequestParams,
    SnapshotDownloadSnapshotRequestParams,
    SnapshotSnapshotsByEngagementIdRequestParams
} from './snapshot.serviceInterface';



/**
  * @param requestParameters
  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  * @param reportProgress flag to report request and response progress.
  */
export function snapshotCreateSnapshot(httpClient: HttpClient, requestParameters: SnapshotCreateSnapshotRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Promise<BusinessResultOfCommandResult | undefined>;
export function snapshotCreateSnapshot(httpClient: HttpClient, requestParameters: SnapshotCreateSnapshotRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Promise<HttpResponse<BusinessResultOfCommandResult | undefined>>;
export function snapshotCreateSnapshot(httpClient: HttpClient, requestParameters: SnapshotCreateSnapshotRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Promise<HttpEvent<BusinessResultOfCommandResult | undefined>>;
export function snapshotCreateSnapshot(httpClient: HttpClient, requestParameters: SnapshotCreateSnapshotRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Promise<any> {
    const request = requestParameters.request;

    let localVarHeaders = defaultHeaders;

    return httpClient.request<BusinessResultOfCommandResult | undefined>(httpMethods.post, `${baseUrl}${getApiBaseHref()}/v6/snapshot/Snapshot/CreateSnapshot`,
        {
            context: getHttpContext(options),
            body: request,
            observe,
            reportProgress
        }
    ).toPromise();
}

/**
  * @param requestParameters
  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  * @param reportProgress flag to report request and response progress.
  */
export function snapshotDeleteSnapshot(httpClient: HttpClient, requestParameters: SnapshotDeleteSnapshotRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Promise<BusinessResultOfCommandResult | undefined>;
export function snapshotDeleteSnapshot(httpClient: HttpClient, requestParameters: SnapshotDeleteSnapshotRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Promise<HttpResponse<BusinessResultOfCommandResult | undefined>>;
export function snapshotDeleteSnapshot(httpClient: HttpClient, requestParameters: SnapshotDeleteSnapshotRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Promise<HttpEvent<BusinessResultOfCommandResult | undefined>>;
export function snapshotDeleteSnapshot(httpClient: HttpClient, requestParameters: SnapshotDeleteSnapshotRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Promise<any> {
    const request = requestParameters.request;

    let localVarHeaders = defaultHeaders;

    return httpClient.request<BusinessResultOfCommandResult | undefined>(httpMethods.post, `${baseUrl}${getApiBaseHref()}/v6/snapshot/Snapshot/DeleteSnapshot`,
        {
            context: getHttpContext(options),
            body: request,
            observe,
            reportProgress
        }
    ).toPromise();
}

/**
  * @param requestParameters
  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  * @param reportProgress flag to report request and response progress.
  */
export function snapshotDownloadSnapshot(httpClient: HttpClient, requestParameters: SnapshotDownloadSnapshotRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Promise<BusinessResultOfDownloadEngagementSnapshotResult | undefined>;
export function snapshotDownloadSnapshot(httpClient: HttpClient, requestParameters: SnapshotDownloadSnapshotRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Promise<HttpResponse<BusinessResultOfDownloadEngagementSnapshotResult | undefined>>;
export function snapshotDownloadSnapshot(httpClient: HttpClient, requestParameters: SnapshotDownloadSnapshotRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Promise<HttpEvent<BusinessResultOfDownloadEngagementSnapshotResult | undefined>>;
export function snapshotDownloadSnapshot(httpClient: HttpClient, requestParameters: SnapshotDownloadSnapshotRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Promise<any> {
    const request = requestParameters.request;

    let localVarHeaders = defaultHeaders;

    return httpClient.request<BusinessResultOfDownloadEngagementSnapshotResult | undefined>(httpMethods.post, `${baseUrl}${getApiBaseHref()}/v6/snapshot/Snapshot/DownloadSnapshot`,
        {
            context: getHttpContext(options),
            body: request,
            observe,
            reportProgress
        }
    ).toPromise();
}

/**
  * @param requestParameters
  * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
  * @param reportProgress flag to report request and response progress.
  */
export function snapshotSnapshotsByEngagementId(httpClient: HttpClient, requestParameters: SnapshotSnapshotsByEngagementIdRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Promise<BusinessResultOfListOfEngagementSnapshot | undefined>;
export function snapshotSnapshotsByEngagementId(httpClient: HttpClient, requestParameters: SnapshotSnapshotsByEngagementIdRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Promise<HttpResponse<BusinessResultOfListOfEngagementSnapshot | undefined>>;
export function snapshotSnapshotsByEngagementId(httpClient: HttpClient, requestParameters: SnapshotSnapshotsByEngagementIdRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Promise<HttpEvent<BusinessResultOfListOfEngagementSnapshot | undefined>>;
export function snapshotSnapshotsByEngagementId(httpClient: HttpClient, requestParameters: SnapshotSnapshotsByEngagementIdRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext}): Promise<any> {
    const request = requestParameters.request;

    let localVarHeaders = defaultHeaders;

    return httpClient.request<BusinessResultOfListOfEngagementSnapshot | undefined>(httpMethods.post, `${baseUrl}${getApiBaseHref()}/v6/snapshot/Snapshot/SnapshotsByEngagementId`,
        {
            context: getHttpContext(options),
            body: request,
            observe,
            reportProgress
        }
    ).toPromise();
}

